import React, { ComponentProps } from 'react';

import ProjectPageLayout from '@adsk/alloy-project-page-layout';
import { PRODUCT_IDS, TOOL_IDS } from '@adsk/alloy-provider';
import SideNavigation from '@adsk/alloy-side-navigation';
import { RemoteComponent, TabTitle } from '@adsk/exo-skeleton-react';

import { Route, LAYOUTS } from '../types';
import { ACC_FILES_EXTRACTION_FLOW_REMOTE_CONFIG } from './helpers/accFilesExtraction';
import {
  ACCOUNT_ADMIN_LAYOUT_PROPS,
  ACCOUNT_ADMIN_NO_SIDE_NAVIGATION_LAYOUT_PROPS,
} from './helpers/accountAdminHelpers';
import {
  ACC_SHEETS_PUBLISH_LOG_REMOTE_CONFIG,
  ACC_SHEETS_PUBLISH_FLOW_REMOTE_CONFIG,
} from './helpers/accSheetsPublish';
import RemoteSideNavigation from '../../components/RemoteSideNavigation/RemoteSideNavigation';
import { getParamFromLocationSearchParams } from '../../utils/getParamFromLocationSearchParams';

export default [
  {
    path: '/build/demo-app/*',
    scope: 'accDemoApp',
    layout: LAYOUTS.PROJECT_PAGE_LAYOUT,
    modulePath: './App',
    layoutProps: {
      currentToolId: 'demo-app',
      currentProductId: PRODUCT_IDS.BUILD,
    },
  },
  {
    path: '/build/new-user-info/*',
    scope: 'accMkto',
    layout: LAYOUTS.FULL_PAGE_LAYOUT,
    modulePath: './NewUserInfo',
  },
  {
    path: '/build/new-user-info-done/*',
    scope: 'accMkto',
    layout: LAYOUTS.FULL_PAGE_LAYOUT,
    modulePath: './NewUserInfo',
  },
  {
    path: '/build/signup-next-steps/*',
    scope: 'accMkto',
    layout: LAYOUTS.FULL_PAGE_LAYOUT,
    modulePath: './SignUpNextSteps',
  },
  {
    path: '/build/correspondence/*',
    scope: 'accCorrespondence',
    layout: LAYOUTS.PROJECT_PAGE_LAYOUT,
    modulePath: './App',
    layoutProps: {
      currentToolId: TOOL_IDS.CORRESPONDENCE,
      currentProductId: PRODUCT_IDS.BUILD,
      redirectToProductIds: [
        PRODUCT_IDS.MODEL_COORDINATION,
        PRODUCT_IDS.DESIGN_COLLABORATION,
      ],
    },
  },
  {
    path: '/dc/correspondence/*',
    scope: 'accCorrespondence',
    layout: LAYOUTS.PROJECT_PAGE_LAYOUT,
    modulePath: './App',
    layoutProps: {
      currentToolId: TOOL_IDS.CORRESPONDENCE,
      currentProductId: PRODUCT_IDS.DESIGN_COLLABORATION,
      redirectToProductIds: [PRODUCT_IDS.BUILD, PRODUCT_IDS.MODEL_COORDINATION],
    },
  },
  {
    path: '/model/correspondence/*',
    scope: 'accCorrespondence',
    layout: LAYOUTS.PROJECT_PAGE_LAYOUT,
    modulePath: './App',
    layoutProps: {
      currentToolId: TOOL_IDS.CORRESPONDENCE,
      currentProductId: PRODUCT_IDS.MODEL_COORDINATION,
      redirectToProductIds: [
        PRODUCT_IDS.BUILD,
        PRODUCT_IDS.DESIGN_COLLABORATION,
      ],
    },
  },
  {
    path: '/build/meetings/*',
    scope: 'accMeetings',
    layout: LAYOUTS.PROJECT_PAGE_LAYOUT,
    modulePath: './App',
    layoutProps: {
      currentToolId: TOOL_IDS.MEETINGS,
      currentProductId: PRODUCT_IDS.BUILD,
      redirectToProductIds: [
        PRODUCT_IDS.MODEL_COORDINATION,
        PRODUCT_IDS.DESIGN_COLLABORATION,
      ],
    },
  },
  {
    path: '/model/meetings/*',
    scope: 'accMeetings',
    layout: LAYOUTS.PROJECT_PAGE_LAYOUT,
    modulePath: './App',
    layoutProps: {
      currentToolId: TOOL_IDS.MEETINGS,
      currentProductId: PRODUCT_IDS.MODEL_COORDINATION,
      redirectToProductIds: [
        PRODUCT_IDS.BUILD,
        PRODUCT_IDS.DESIGN_COLLABORATION,
      ],
    },
  },
  {
    path: '/dc/meetings/*',
    scope: 'accMeetings',
    layout: LAYOUTS.PROJECT_PAGE_LAYOUT,
    modulePath: './App',
    layoutProps: {
      currentToolId: TOOL_IDS.MEETINGS,
      currentProductId: PRODUCT_IDS.DESIGN_COLLABORATION,
      redirectToProductIds: [PRODUCT_IDS.BUILD, PRODUCT_IDS.MODEL_COORDINATION],
    },
  },
  {
    path: '/build/rfis/*',
    scope: 'accRfis',
    layout: LAYOUTS.PROJECT_PAGE_LAYOUT,
    modulePath: './App',
    layoutProps: {
      currentToolId: TOOL_IDS.RFIS,
      currentProductId: PRODUCT_IDS.BUILD,
    },
  },
  {
    path: '/build/photos/*',
    scope: 'acsPhotos',
    layout: LAYOUTS.PROJECT_PAGE_LAYOUT,
    modulePath: './App',
    layoutProps: {
      currentToolId: TOOL_IDS.PHOTOS,
      currentProductId: PRODUCT_IDS.BUILD,
    },
  },
  {
    path: '/build/schedule/*',
    scope: 'accSchedule',
    layout: LAYOUTS.PROJECT_PAGE_LAYOUT,
    modulePath: './App',
    layoutProps: {
      currentToolId: TOOL_IDS.SCHEDULE,
      currentProductId: PRODUCT_IDS.BUILD,
    },
  },
  {
    path: '/build/files/*',
    scope: 'accDocs',
    layout: LAYOUTS.PROJECT_PAGE_LAYOUT,
    modulePath: './App',
    layoutProps: {
      currentToolId: TOOL_IDS.DOCUMENTS,
      currentProductId: PRODUCT_IDS.BUILD,
    },
  },
  {
    path: '/build/sheets/*',
    scope: 'accSheets',
    layout: LAYOUTS.PROJECT_PAGE_LAYOUT,
    modulePath: './App',
    layoutProps: {
      currentToolId: TOOL_IDS.SHEETS,
      currentProductId: PRODUCT_IDS.BUILD,
    },
  },

  // Sheets publish flow & publish log
  {
    ...ACC_SHEETS_PUBLISH_LOG_REMOTE_CONFIG,
    path: '/build/sheets-publish/projects/:projectId/log',
  },
  {
    ...ACC_SHEETS_PUBLISH_LOG_REMOTE_CONFIG,
    path: '/takeoff/sheets-publish/projects/:projectId/log',
    layoutProps: {
      ...ACC_SHEETS_PUBLISH_LOG_REMOTE_CONFIG.layoutProps,
      currentProductId: PRODUCT_IDS.TAKEOFF,
    },
  },
  {
    ...ACC_SHEETS_PUBLISH_FLOW_REMOTE_CONFIG,
    path: '/build/sheets-publish/projects/:projectId/*',
  },
  {
    ...ACC_SHEETS_PUBLISH_FLOW_REMOTE_CONFIG,
    path: '/takeoff/sheets-publish/projects/:projectId/*',
    layoutProps: {
      ...ACC_SHEETS_PUBLISH_FLOW_REMOTE_CONFIG.layoutProps,
      currentProductId: PRODUCT_IDS.TAKEOFF,
    },
  },

  // Files extraction flow
  {
    ...ACC_FILES_EXTRACTION_FLOW_REMOTE_CONFIG,
    path: '/build/process-files/projects/:projectId/*',
  },
  {
    ...ACC_FILES_EXTRACTION_FLOW_REMOTE_CONFIG,
    path: '/takeoff/process-files/projects/:projectId/*',
    layoutProps: {
      ...ACC_FILES_EXTRACTION_FLOW_REMOTE_CONFIG.layoutProps,
      currentProductId: PRODUCT_IDS.TAKEOFF,
    },
  },
  {
    ...ACC_FILES_EXTRACTION_FLOW_REMOTE_CONFIG,
    path: '/docs/process-files/projects/:projectId/*',
    layoutProps: {
      ...ACC_FILES_EXTRACTION_FLOW_REMOTE_CONFIG.layoutProps,
      currentProductId: PRODUCT_IDS.DOCS,
    },
  },
  {
    ...ACC_FILES_EXTRACTION_FLOW_REMOTE_CONFIG,
    path: '/cost/process-files/projects/:projectId/*',
    layoutProps: {
      ...ACC_FILES_EXTRACTION_FLOW_REMOTE_CONFIG.layoutProps,
      currentProductId: PRODUCT_IDS.COST,
    },
  },
  {
    path: '/build/specifications/*',
    scope: 'accSpecs',
    layout: LAYOUTS.PROJECT_PAGE_LAYOUT,
    modulePath: './App',
    layoutProps: {
      currentToolId: TOOL_IDS.SPECS,
      currentProductId: PRODUCT_IDS.BUILD,
    },
  },
  {
    path: '/docs/specifications/*',
    scope: 'accSpecs',
    layout: LAYOUTS.PROJECT_PAGE_LAYOUT,
    modulePath: './App',
    layoutProps: {
      currentToolId: TOOL_IDS.SPECS,
      currentProductId: PRODUCT_IDS.DOCS,
    },
  },
  {
    path: '/takeoff/specifications/*',
    scope: 'accSpecs',
    layout: LAYOUTS.PROJECT_PAGE_LAYOUT,
    modulePath: './App',
    layoutProps: {
      currentToolId: TOOL_IDS.SPECS,
      currentProductId: PRODUCT_IDS.TAKEOFF,
    },
  },
  {
    path: '/build/share/*',
    scope: 'accDocsShare',
    modulePath: './App',
    layout: LAYOUTS.PUBLIC_PAGE_LAYOUT,
    customTitle: <TabTitle productId={PRODUCT_IDS.BUILD} />,
  },
  {
    path: '/docs/files/*',
    scope: 'accDocs',
    layout: LAYOUTS.PROJECT_PAGE_LAYOUT,
    modulePath: './App',
    layoutProps: {
      currentToolId: TOOL_IDS.DOCUMENTS,
      currentProductId: PRODUCT_IDS.DOCS,
    },
  },
  {
    path: '/docs/reviews/*',
    scope: 'accDocs',
    layout: LAYOUTS.PROJECT_PAGE_LAYOUT,
    modulePath: './App',
    layoutProps: {
      currentToolId: TOOL_IDS.REVIEWS,
      currentProductId: PRODUCT_IDS.DOCS,
    },
  },
  {
    path: '/docs/transmittals/*',
    scope: 'accDocs',
    layout: LAYOUTS.PROJECT_PAGE_LAYOUT,
    modulePath: './App',
    layoutProps: {
      currentToolId: TOOL_IDS.TRANSMITTALS,
      currentProductId: PRODUCT_IDS.DOCS,
    },
  },
  {
    path: '/docs/settings/*',
    scope: 'accDocs',
    layout: LAYOUTS.PROJECT_PAGE_LAYOUT,
    modulePath: './App',
    layoutProps: {
      currentToolId: TOOL_IDS.SETTINGS,
      currentProductId: PRODUCT_IDS.DOCS,
    },
  },
  {
    path: '/docs/share/*',
    scope: 'accDocsShare',
    modulePath: './App',
    layout: LAYOUTS.PUBLIC_PAGE_LAYOUT,
    customTitle: <TabTitle productId={PRODUCT_IDS.DOCS} />,
  },
  {
    path: '/cost/files/*',
    scope: 'accDocs',
    layout: LAYOUTS.PROJECT_PAGE_LAYOUT,
    modulePath: './App',
    layoutProps: {
      currentToolId: TOOL_IDS.DOCUMENTS,
      currentProductId: PRODUCT_IDS.COST,
      renderSideNavigation: (props: ComponentProps<typeof SideNavigation>) => (
        <RemoteSideNavigation
          scope="accCost"
          moduleName="./SideNavigation"
          selectedId={TOOL_IDS.DOCUMENTS}
          {...props}
        />
      ),
    },
  },
  {
    path: '/autospecs/files/*',
    scope: 'accDocs',
    layout: LAYOUTS.PROJECT_PAGE_LAYOUT,
    modulePath: './App',
    layoutProps: {
      currentToolId: TOOL_IDS.DOCUMENTS,
      currentProductId: PRODUCT_IDS.AUTOSPECS,
    },
  },
  {
    path: '/autospecs/home/*',
    scope: 'accAutoSpecs',
    modulePath: './HomeApp',
    layout: LAYOUTS.PROJECT_PAGE_LAYOUT,
    layoutProps: {
      currentToolId: TOOL_IDS.HOME,
      currentProductId: PRODUCT_IDS.AUTOSPECS,
    },
  },
  {
    path: '/autospecs/requirementsoverview/*',
    scope: 'accAutoSpecs',
    modulePath: './RequirementsApp',
    layout: LAYOUTS.PROJECT_PAGE_LAYOUT,
    layoutProps: {
      currentToolId: TOOL_IDS.HOME,
      currentProductId: PRODUCT_IDS.AUTOSPECS,
    },
  },
  {
    path: '/autospecs/uploadspecs/*',
    scope: 'accAutoSpecs',
    modulePath: './UploadSpecsApp',
    layout: LAYOUTS.PROJECT_PAGE_LAYOUT,
    layoutProps: {
      currentToolId: TOOL_IDS.HOME,
      currentProductId: PRODUCT_IDS.AUTOSPECS,
    },
  },
  {
    path: '/autospecs/addendum/*',
    scope: 'accAutoSpecs',
    modulePath: './AddendumApp',
    layout: LAYOUTS.PROJECT_PAGE_LAYOUT,
    layoutProps: {
      currentToolId: TOOL_IDS.HOME,
      currentProductId: PRODUCT_IDS.AUTOSPECS,
    },
  },
  {
    path: '/takeoff/files/*',
    scope: 'accDocs',
    layout: LAYOUTS.PROJECT_PAGE_LAYOUT,
    modulePath: './App',
    layoutProps: {
      currentToolId: TOOL_IDS.DOCUMENTS,
      currentProductId: PRODUCT_IDS.TAKEOFF,
    },
  },
  {
    path: '/build/submittals/*',
    scope: 'accSubmittals',
    layout: LAYOUTS.PROJECT_PAGE_LAYOUT,
    modulePath: './App',
    layoutProps: {
      currentToolId: TOOL_IDS.SUBMITTALS,
      currentProductId: PRODUCT_IDS.BUILD,
    },
  },
  {
    path: '/projects/*',
    scope: 'accProjectList',
    modulePath: './App',
    layout: LAYOUTS.PROJECT_DIRECTORY_LAYOUT,
  },
  {
    path: '/home',
    scope: 'accProjectList',
    modulePath: './App',
    layout: LAYOUTS.PROJECT_DIRECTORY_LAYOUT,
  },
  {
    path: '/project-admin/activity/projects/:projectId/*',
    scope: 'acsInsight',
    modulePath: './ActivityLog',
    layout: LAYOUTS.PROJECT_PAGE_LAYOUT,
    layoutProps: {
      currentToolId: TOOL_IDS.ACTIVITY,
      currentProductId: PRODUCT_IDS.PROJECT_ADMINISTRATION,
    },
  },
  {
    path: '/build/home/*',
    scope: 'acsInsight',
    modulePath: './BuildProjectHome',
    layout: LAYOUTS.PROJECT_PAGE_LAYOUT,
    layoutProps: {
      currentToolId: TOOL_IDS.HOME,
      currentProductId: PRODUCT_IDS.BUILD,
    },
  },
  {
    path: '/project-admin/template-notifications/projects/:projectId/',
    modulePath: './ProjectSettings',
    scope: 'accNotifications',
    layout: LAYOUTS.PROJECT_PAGE_LAYOUT,
    layoutProps: {
      currentToolId: TOOL_IDS.TEMPLATE_NOTIFICATIONS,
      currentProductId: PRODUCT_IDS.PROJECT_ADMINISTRATION,
    },
  },
  {
    path: '/project-admin/notifications/projects/:projectId/',
    modulePath: './ProjectSettings',
    scope: 'accNotifications',
    layout: LAYOUTS.PROJECT_PAGE_LAYOUT,
    layoutProps: {
      currentToolId: TOOL_IDS.NOTIFICATIONS,
      currentProductId: PRODUCT_IDS.PROJECT_ADMINISTRATION,
    },
  },
  {
    path: '/settings/projects/:projectId/notifications',
    scope: 'accNotifications',
    modulePath: './UserSettings',
    layout: LAYOUTS.PROJECT_PAGE_LAYOUT,
    layoutProps: {
      currentToolId: TOOL_IDS.NOTIFICATIONS,
      currentProductId: null,
      renderSideNavigation: () => null,
      showAccountsInHeader: false,
      isProductRequired: false,
    },
  },
  {
    path: '/project-admin/handover/projects/:projectId/download',
    scope: 'accHandover',
    modulePath: './DownloadPage',
    layout: LAYOUTS.PROJECT_PAGE_LAYOUT,
    layoutProps: {
      currentToolId: TOOL_IDS.HANDOVER,
      currentProductId: PRODUCT_IDS.PROJECT_ADMINISTRATION,
      renderSideNavigation: () => null,
    },
  },
  {
    path: '/project-admin/handover/projects/:projectId/*',
    scope: 'accHandover',
    modulePath: './Handover',
    layout: LAYOUTS.PROJECT_PAGE_LAYOUT,
    layoutProps: {
      currentToolId: TOOL_IDS.HANDOVER,
      currentProductId: PRODUCT_IDS.PROJECT_ADMINISTRATION,
    },
  },
  {
    path: '/account-admin/components/accounts/:accountId',
    scope: 'accLibrary',
    modulePath: './App',
    layout: LAYOUTS.PROJECT_PAGE_LAYOUT,
    layoutProps: ACCOUNT_ADMIN_LAYOUT_PROPS,
  },
  {
    path: '/account-admin/components/accounts/:accountId/cost',
    scope: 'accLibrary',
    modulePath: './App',
    layout: LAYOUTS.PROJECT_PAGE_LAYOUT,
    layoutProps: ACCOUNT_ADMIN_LAYOUT_PROPS,
  },
  {
    path: '/account-admin/components/accounts/:accountId/cost/create',
    scope: 'accCost',
    modulePath: './Main',
    layout: LAYOUTS.PROJECT_PAGE_LAYOUT,
    layoutProps: ACCOUNT_ADMIN_NO_SIDE_NAVIGATION_LAYOUT_PROPS,
  },
  {
    path: '/account-admin/components/accounts/:accountId/cost/:assetId',
    scope: 'accCost',
    modulePath: './Main',
    layout: LAYOUTS.PROJECT_PAGE_LAYOUT,
    layoutProps: ACCOUNT_ADMIN_NO_SIDE_NAVIGATION_LAYOUT_PROPS,
  },
  {
    path: '/account-admin/components/accounts/:accountId/forms',
    scope: 'accLibrary',
    modulePath: './App',
    layout: LAYOUTS.PROJECT_PAGE_LAYOUT,
    layoutProps: ACCOUNT_ADMIN_LAYOUT_PROPS,
  },
  {
    path: '/account-admin/components/accounts/:accountId/forms/*',
    scope: 'accForms',
    layout: LAYOUTS.PROJECT_PAGE_LAYOUT,
    modulePath: './App',
    layoutProps: {
      ...ACCOUNT_ADMIN_NO_SIDE_NAVIGATION_LAYOUT_PROPS,
      currentToolId: TOOL_IDS.FORMS,
    },
  },
  {
    path: '/account-admin/components/accounts/:accountId/meetings',
    scope: 'accLibrary',
    modulePath: './App',
    layout: LAYOUTS.PROJECT_PAGE_LAYOUT,
    layoutProps: ACCOUNT_ADMIN_LAYOUT_PROPS,
  },
  {
    path: '/account-admin/components/accounts/:accountId/meetings/*',
    scope: 'accMeetings',
    modulePath: './ComponentLibrary',
    layout: LAYOUTS.PROJECT_PAGE_LAYOUT,
    layoutProps: ACCOUNT_ADMIN_NO_SIDE_NAVIGATION_LAYOUT_PROPS,
  },
  {
    path: '/account-admin/components/accounts/:accountId/parameters',
    scope: 'accLibrary',
    modulePath: './App',
    layout: LAYOUTS.PROJECT_PAGE_LAYOUT,
    layoutProps: ACCOUNT_ADMIN_LAYOUT_PROPS,
  },
  {
    path: '/account-admin/components/accounts/:accountId/parameters/create',
    scope: 'accParameters',
    modulePath: './CreateParameters',
    layout: LAYOUTS.PROJECT_PAGE_LAYOUT,
    layoutProps: ACCOUNT_ADMIN_NO_SIDE_NAVIGATION_LAYOUT_PROPS,
  },
  {
    path: '/account-admin/components/accounts/:accountId/parameters/:parameterId',
    scope: 'accParameters',
    modulePath: './EditParameters',
    layout: LAYOUTS.PROJECT_PAGE_LAYOUT,
    layoutProps: ACCOUNT_ADMIN_NO_SIDE_NAVIGATION_LAYOUT_PROPS,
  },
  {
    path: '/account-admin/components/accounts/:accountId/design-management',
    scope: 'accLibrary',
    modulePath: './App',
    layout: LAYOUTS.PROJECT_PAGE_LAYOUT,
    layoutProps: ACCOUNT_ADMIN_LAYOUT_PROPS,
  },
  {
    path: '/build/bridge/accept/:inviteId',
    scope: 'accBridge',
    modulePath: './AppAcceptInviteModal',
    layout: LAYOUTS.PUBLIC_PAGE_LAYOUT,
    customTitle: <TabTitle productId={PRODUCT_IDS.BUILD} />,
  },
  {
    path: '/build/bridge/projects/:projectId/*',
    scope: 'accBridge',
    modulePath: './AppBridge',
    layout: LAYOUTS.PROJECT_PAGE_LAYOUT,
    layoutProps: {
      currentToolId: TOOL_IDS.BRIDGE,
      currentProductId: PRODUCT_IDS.BUILD,
      variant: 'project',
      isUsersConstructionApi: true,
    },
  },
  {
    path: '/docs/bridge/projects/:projectId/*',
    scope: 'accBridge',
    modulePath: './AppBridge',
    layout: LAYOUTS.PROJECT_PAGE_LAYOUT,
    layoutProps: {
      currentToolId: TOOL_IDS.BRIDGE,
      currentProductId: PRODUCT_IDS.DOCS,
      variant: 'project',
      isUsersConstructionApi: true,
    },
  },
  {
    path: '/dc/bridge/projects/:projectId/*',
    scope: 'accBridge',
    modulePath: './AppBridge',
    layout: LAYOUTS.PROJECT_PAGE_LAYOUT,
    layoutProps: {
      currentToolId: TOOL_IDS.BRIDGE,
      currentProductId: PRODUCT_IDS.DESIGN_COLLABORATION,
      variant: 'project',
      isUsersConstructionApi: true,
    },
  },
  {
    path: '/project-admin/bridge/projects/:projectId/*',
    scope: 'accBridge',
    modulePath: './AppBridge',
    layout: LAYOUTS.PROJECT_PAGE_LAYOUT,
    layoutProps: {
      currentToolId: TOOL_IDS.BRIDGE,
      currentProductId: PRODUCT_IDS.PROJECT_ADMINISTRATION,
      variant: 'project',
      isUsersConstructionApi: true,
    },
  },
  {
    path: '/account-admin/templates/accounts/:accountId/*',
    scope: 'accTemplateAdmin',
    modulePath: './TemplateAdmin',
    layout: LAYOUTS.PROJECT_PAGE_LAYOUT,
    layoutProps: {
      ...ACCOUNT_ADMIN_LAYOUT_PROPS,
      currentToolId: TOOL_IDS.TEMPLATES,
    },
  },
  {
    path: '/account-admin/projects/accounts/:accountId/*',
    scope: 'missionControlFrontend',
    modulePath: './AccountProjects',
    layout: LAYOUTS.PROJECT_PAGE_LAYOUT,
    layoutProps: {
      ...ACCOUNT_ADMIN_LAYOUT_PROPS,
      currentToolId: TOOL_IDS.PROJECTS,
    },
  },
  {
    path: '/account-admin/members/accounts/:accountId/member/:userId',
    scope: 'missionControlFrontend',
    modulePath: './AccountMemberDetails',
    layout: LAYOUTS.PROJECT_PAGE_LAYOUT,
    layoutProps: {
      ...ACCOUNT_ADMIN_LAYOUT_PROPS,
      currentToolId: TOOL_IDS.TEAM,
    },
  },
  {
    path: '/account-admin/members/accounts/:accountId/*',
    scope: 'accAdminClient',
    modulePath: './AccountAdmin',
    layout: LAYOUTS.PROJECT_PAGE_LAYOUT,
    layoutProps: {
      ...ACCOUNT_ADMIN_LAYOUT_PROPS,
      currentToolId: TOOL_IDS.TEAM,
    },
  },
  {
    path: '/account-admin/members-invite/accounts/:accountId/*',
    scope: 'accAdminClient',
    modulePath: './AccountAdmin',
    layout: LAYOUTS.PROJECT_PAGE_LAYOUT,
    layoutProps: {
      ...ACCOUNT_ADMIN_NO_SIDE_NAVIGATION_LAYOUT_PROPS,
      currentToolId: TOOL_IDS.TEAM,
    },
  },
  {
    path: '/account-admin/companies/accounts/:accountId/*',
    scope: 'accAdminClient',
    modulePath: './AccountAdmin',
    layout: LAYOUTS.PROJECT_PAGE_LAYOUT,
    layoutProps: ACCOUNT_ADMIN_LAYOUT_PROPS,
  },
  {
    path: '/account-admin/roles/accounts/:accountId/*',
    scope: 'missionControlFrontend',
    modulePath: './AccountRoles',
    layout: LAYOUTS.PROJECT_PAGE_LAYOUT,
    layoutProps: {
      ...ACCOUNT_ADMIN_LAYOUT_PROPS,
      currentToolId: TOOL_IDS.ROLES,
    },
  },
  {
    path: '/account-admin/settings/accounts/:accountId/*',
    scope: 'accAdminClient',
    modulePath: './AccountAdmin',
    layout: LAYOUTS.PROJECT_PAGE_LAYOUT,
    layoutProps: {
      ...ACCOUNT_ADMIN_LAYOUT_PROPS,
      currentToolId: TOOL_IDS.SETTINGS,
    },
  },
  {
    path: '/account-admin/links/accounts/:accountId/*',
    scope: 'missionControlFrontend',
    modulePath: './AccountLinks',
    layout: LAYOUTS.PROJECT_PAGE_LAYOUT,
    layoutProps: ACCOUNT_ADMIN_LAYOUT_PROPS,
  },
  {
    path: '/account-admin/custom-integrations/accounts/:accountId/*',
    scope: 'missionControlFrontend',
    modulePath: './AccountCustomIntegrations',
    layout: LAYOUTS.PROJECT_PAGE_LAYOUT,
    layoutProps: ACCOUNT_ADMIN_LAYOUT_PROPS,
  },
  {
    path: '/account-admin/controls-center/accounts/:accountId/*',
    scope: 'accTemplateAdmin',
    modulePath: './ProductsAndToolsAccount',
    layout: LAYOUTS.PROJECT_PAGE_LAYOUT,
    layoutProps: ACCOUNT_ADMIN_LAYOUT_PROPS,
  },
  {
    path: '/project-admin/template-settings/projects/*',
    scope: 'accTemplateAdmin',
    modulePath: './TemplateSettings',
    layout: LAYOUTS.PROJECT_PAGE_LAYOUT,
    layoutProps: {
      isUsersConstructionApi: true,
      currentToolId: TOOL_IDS.CONFIGURATION,
      currentProductId: PRODUCT_IDS.PROJECT_ADMINISTRATION,
    },
  },
  {
    path: '/account-admin/apps/*',
    scope: 'accApps',
    modulePath: './App',
    layout: LAYOUTS.PROJECT_PAGE_LAYOUT,
    layoutProps: {
      ...ACCOUNT_ADMIN_LAYOUT_PROPS,
      currentToolId: TOOL_IDS.APPS,
    },
  },
  {
    path: '/build/template-settings/projects/*',
    scope: 'accTemplateAdmin',
    modulePath: './TemplateSettings',
    layout: LAYOUTS.PROJECT_PAGE_LAYOUT,
    layoutProps: {
      isUsersConstructionApi: true,
      currentToolId: TOOL_IDS.CONFIGURATION,
      currentProductId: PRODUCT_IDS.BUILD,
    },
  },
  {
    path: '/cost/template-settings/projects/*',
    scope: 'accTemplateAdmin',
    modulePath: './TemplateSettings',
    layout: LAYOUTS.PROJECT_PAGE_LAYOUT,
    layoutProps: {
      isUsersConstructionApi: true,
      currentToolId: TOOL_IDS.CONFIGURATION,
      currentProductId: PRODUCT_IDS.COST,
    },
  },
  {
    path: '/dc/template-settings/projects/*',
    scope: 'accTemplateAdmin',
    modulePath: './TemplateSettings',
    layout: LAYOUTS.PROJECT_PAGE_LAYOUT,
    layoutProps: {
      isUsersConstructionApi: true,
      currentToolId: TOOL_IDS.CONFIGURATION,
      currentProductId: PRODUCT_IDS.DESIGN_COLLABORATION,
    },
  },
  {
    path: '/docs/template-settings/projects/*',
    scope: 'accTemplateAdmin',
    modulePath: './TemplateSettings',
    layout: LAYOUTS.PROJECT_PAGE_LAYOUT,
    layoutProps: {
      isUsersConstructionApi: true,
      currentToolId: TOOL_IDS.CONFIGURATION,
      currentProductId: PRODUCT_IDS.DOCS,
    },
  },
  {
    path: '/takeoff/template-settings/projects/*',
    scope: 'accTemplateAdmin',
    modulePath: './TemplateSettings',
    layout: LAYOUTS.PROJECT_PAGE_LAYOUT,
    layoutProps: {
      isUsersConstructionApi: true,
      currentToolId: TOOL_IDS.CONFIGURATION,
      currentProductId: PRODUCT_IDS.TAKEOFF,
    },
  },
  {
    path: '/project-admin/template-members/projects/*',
    scope: 'accTemplateAdmin',
    modulePath: './TemplateMembers',
    layout: LAYOUTS.PROJECT_PAGE_LAYOUT,
    layoutProps: {
      isUsersConstructionApi: true,
      currentToolId: TOOL_IDS.TEMPLATE_MEMBERS,
      currentProductId: PRODUCT_IDS.PROJECT_ADMINISTRATION,
    },
  },
  {
    path: '/project-admin/controls-center/projects/*',
    scope: 'accTemplateAdmin',
    modulePath: './ProductsAndToolsTemplate',
    layout: LAYOUTS.PROJECT_PAGE_LAYOUT,
    layoutProps: {
      isUsersConstructionApi: true,
      currentToolId: TOOL_IDS.CONTROLS_CENTER,
      currentProductId: PRODUCT_IDS.PROJECT_ADMINISTRATION,
    },
  },
  {
    path: '/build/settings/projects/:projectId',
    scope: 'accAdminClient',
    modulePath: './ProjectAdmin',
    layout: LAYOUTS.PROJECT_PAGE_LAYOUT,
    layoutProps: {
      currentProductId: PRODUCT_IDS.BUILD,
      currentToolId: TOOL_IDS.SETTINGS,
    },
  },
  {
    path: '/autospecs/settings/projects/:projectId',
    scope: 'accAdminClient',
    modulePath: './ProjectAdmin',
    layout: LAYOUTS.PROJECT_PAGE_LAYOUT,
    layoutProps: {
      currentProductId: PRODUCT_IDS.AUTOSPECS,
      currentToolId: TOOL_IDS.SETTINGS,
    },
  },
  {
    path: '/access/blocked',
    scope: 'accAdminClient',
    modulePath: './License',
    layout: LAYOUTS.PUBLIC_PAGE_LAYOUT,
    customTitle: <TabTitle productId={PRODUCT_IDS.PROJECT_ADMINISTRATION} />,
  },
  {
    path: '/access/mfa/*',
    scope: 'accAdminClient',
    modulePath: './License',
    layout: LAYOUTS.PUBLIC_PAGE_LAYOUT,
    customTitle: <TabTitle productId={PRODUCT_IDS.PROJECT_ADMINISTRATION} />,
  },
  {
    path: '/access/project-expired/*',
    scope: 'accAdminClient',
    modulePath: './License',
    layout: LAYOUTS.PUBLIC_PAGE_LAYOUT,
    customTitle: <TabTitle productId={PRODUCT_IDS.PROJECT_ADMINISTRATION} />,
  },
  {
    path: '/access/select-destination/*',
    scope: 'accAdminClient',
    modulePath: './License',
    layout: LAYOUTS.PUBLIC_PAGE_LAYOUT,
    customTitle: <TabTitle productId={PRODUCT_IDS.PROJECT_ADMINISTRATION} />,
  },
  {
    path: '/access/account-expired/*',
    scope: 'accAdminClient',
    modulePath: './License',
    layout: LAYOUTS.PUBLIC_PAGE_LAYOUT,
    customTitle: <TabTitle productId={PRODUCT_IDS.PROJECT_ADMINISTRATION} />,
  },
  {
    path: '/access/start-trial/*',
    scope: 'accAdminClient',
    modulePath: './License',
    layout: LAYOUTS.PUBLIC_PAGE_LAYOUT,
    customTitle: <TabTitle productId={PRODUCT_IDS.PROJECT_ADMINISTRATION} />,
  },
  {
    path: '/access/limit/*',
    scope: 'accAdminClient',
    modulePath: './License',
    layout: LAYOUTS.PROJECT_PAGE_LAYOUT,
    layoutProps: {
      currentProductId: PRODUCT_IDS.PROJECT_ADMINISTRATION,
      dynamicProductIdSetter: ({ location }) =>
        getParamFromLocationSearchParams({ location, param: 'pk' }),
      renderSideNavigation: () => null,
    },
  },
  {
    path: '/access/open/*',
    scope: 'accAdminClient',
    modulePath: './License',
    layout: LAYOUTS.PROJECT_PAGE_LAYOUT,
    layoutProps: {
      currentProductId: PRODUCT_IDS.PROJECT_ADMINISTRATION,
      dynamicProductIdSetter: ({ location }) =>
        getParamFromLocationSearchParams({ location, param: 'pk' }),
      renderSideNavigation: () => null,
    },
  },
  {
    path: '/access/upgrade/*',
    scope: 'accAdminClient',
    modulePath: './License',
    layout: LAYOUTS.PROJECT_PAGE_LAYOUT,
    layoutProps: {
      currentProductId: PRODUCT_IDS.PROJECT_ADMINISTRATION,
      dynamicProductIdSetter: ({ location }) =>
        getParamFromLocationSearchParams({ location, param: 'pk' }),
      renderSideNavigation: () => null,
    },
  },
  {
    path: '/project-admin/members/projects/:projectId/*',
    scope: 'accAdminClient',
    modulePath: './ProjectAdmin',
    layout: LAYOUTS.PROJECT_PAGE_LAYOUT,
    layoutProps: {
      currentProductId: PRODUCT_IDS.PROJECT_ADMINISTRATION,
      currentToolId: TOOL_IDS.TEAM,
    },
  },
  {
    path: '/project-admin/members-invite/projects/:projectId/*',
    scope: 'accAdminClient',
    modulePath: './ProjectAdmin',
    layout: LAYOUTS.PROJECT_PAGE_LAYOUT,
    layoutProps: {
      currentProductId: PRODUCT_IDS.PROJECT_ADMINISTRATION,
      currentToolId: TOOL_IDS.TEAM,
      renderSideNavigation: () => null,
    },
  },
  {
    path: '/docs/members/projects/:projectId/*',
    scope: 'accAdminClient',
    modulePath: './ProjectAdmin',
    layout: LAYOUTS.PROJECT_PAGE_LAYOUT,
    layoutProps: {
      currentProductId: PRODUCT_IDS.DOCS,
      currentToolId: TOOL_IDS.TEAM,
    },
  },
  {
    path: '/docs/members-invite/projects/:projectId/*',
    scope: 'accAdminClient',
    modulePath: './ProjectAdmin',
    layout: LAYOUTS.PROJECT_PAGE_LAYOUT,
    layoutProps: {
      currentProductId: PRODUCT_IDS.DOCS,
      currentToolId: TOOL_IDS.TEAM,
      renderSideNavigation: () => null,
    },
  },
  {
    path: '/build/members/projects/:projectId/*',
    scope: 'accAdminClient',
    modulePath: './ProjectAdmin',
    layout: LAYOUTS.PROJECT_PAGE_LAYOUT,
    layoutProps: {
      currentProductId: PRODUCT_IDS.BUILD,
      currentToolId: TOOL_IDS.TEAM,
    },
  },
  {
    path: '/build/members-invite/projects/:projectId/*',
    scope: 'accAdminClient',
    modulePath: './ProjectAdmin',
    layout: LAYOUTS.PROJECT_PAGE_LAYOUT,
    layoutProps: {
      currentProductId: PRODUCT_IDS.BUILD,
      currentToolId: TOOL_IDS.TEAM,
      renderSideNavigation: () => null,
    },
  },
  {
    path: '/cost/members/projects/:projectId/*',
    scope: 'accAdminClient',
    modulePath: './ProjectAdmin',
    layout: LAYOUTS.PROJECT_PAGE_LAYOUT,
    layoutProps: {
      currentProductId: PRODUCT_IDS.COST,
      currentToolId: TOOL_IDS.TEAM,
      renderSideNavigation: (props: ComponentProps<typeof SideNavigation>) => (
        <RemoteSideNavigation
          scope="accCost"
          moduleName="./SideNavigation"
          selectedId={TOOL_IDS.MEMBERS}
          {...props}
        />
      ),
    },
  },
  {
    path: '/cost/members-invite/projects/:projectId/*',
    scope: 'accAdminClient',
    modulePath: './ProjectAdmin',
    layout: LAYOUTS.PROJECT_PAGE_LAYOUT,
    layoutProps: {
      currentProductId: PRODUCT_IDS.COST,
      currentToolId: TOOL_IDS.TEAM,
      renderSideNavigation: () => null,
    },
  },
  {
    path: '/takeoff/members/projects/:projectId/*',
    scope: 'accAdminClient',
    modulePath: './ProjectAdmin',
    layout: LAYOUTS.PROJECT_PAGE_LAYOUT,
    layoutProps: {
      currentProductId: PRODUCT_IDS.TAKEOFF,
      currentToolId: TOOL_IDS.TEAM,
    },
  },
  {
    path: '/takeoff/members-invite/projects/:projectId/*',
    scope: 'accAdminClient',
    modulePath: './ProjectAdmin',
    layout: LAYOUTS.PROJECT_PAGE_LAYOUT,
    layoutProps: {
      currentProductId: PRODUCT_IDS.TAKEOFF,
      currentToolId: TOOL_IDS.TEAM,
      renderSideNavigation: () => null,
    },
  },
  {
    path: '/model/members/projects/:projectId/*',
    scope: 'accAdminClient',
    modulePath: './ProjectAdmin',
    layout: LAYOUTS.PROJECT_PAGE_LAYOUT,
    layoutProps: {
      currentProductId: PRODUCT_IDS.MODEL_COORDINATION,
      currentToolId: TOOL_IDS.TEAM,
    },
  },
  {
    path: '/model/members-invite/projects/:projectId/*',
    scope: 'accAdminClient',
    modulePath: './ProjectAdmin',
    layout: LAYOUTS.PROJECT_PAGE_LAYOUT,
    layoutProps: {
      currentProductId: PRODUCT_IDS.MODEL_COORDINATION,
      currentToolId: TOOL_IDS.TEAM,
      renderSideNavigation: () => null,
    },
  },
  {
    path: '/dc/members/projects/:projectId/*',
    scope: 'accAdminClient',
    modulePath: './ProjectAdmin',
    layout: LAYOUTS.PROJECT_PAGE_LAYOUT,
    layoutProps: {
      currentProductId: PRODUCT_IDS.DESIGN_COLLABORATION,
      currentToolId: TOOL_IDS.TEAM,
    },
  },
  {
    path: '/dc/members-invite/projects/:projectId/*',
    scope: 'accAdminClient',
    modulePath: './ProjectAdmin',
    layout: LAYOUTS.PROJECT_PAGE_LAYOUT,
    layoutProps: {
      currentProductId: PRODUCT_IDS.DESIGN_COLLABORATION,
      currentToolId: TOOL_IDS.TEAM,
      renderSideNavigation: () => null,
    },
  },
  {
    path: '/autospecs/members/projects/:projectId/*',
    scope: 'accAdminClient',
    modulePath: './ProjectAdmin',
    layout: LAYOUTS.PROJECT_PAGE_LAYOUT,
    layoutProps: {
      currentProductId: PRODUCT_IDS.AUTOSPECS,
      currentToolId: TOOL_IDS.TEAM,
    },
  },
  {
    path: '/autospecs/members-invite/projects/:projectId/*',
    scope: 'accAdminClient',
    modulePath: './ProjectAdmin',
    layout: LAYOUTS.PROJECT_PAGE_LAYOUT,
    layoutProps: {
      currentProductId: PRODUCT_IDS.AUTOSPECS,
      currentToolId: TOOL_IDS.TEAM,
      renderSideNavigation: () => null,
    },
  },
  {
    path: '/project-admin/companies/projects/:projectId/*',
    scope: 'accAdminClient',
    modulePath: './ProjectAdmin',
    layout: LAYOUTS.PROJECT_PAGE_LAYOUT,
    layoutProps: {
      currentProductId: PRODUCT_IDS.PROJECT_ADMINISTRATION,
    },
  },
  {
    path: '/project-admin/settings/projects/:projectId/*',
    scope: 'accAdminClient',
    modulePath: './ProjectAdmin',
    layout: LAYOUTS.PROJECT_PAGE_LAYOUT,
    layoutProps: {
      currentProductId: PRODUCT_IDS.PROJECT_ADMINISTRATION,
      currentToolId: TOOL_IDS.SETTINGS,
    },
  },
  {
    path: '/build/reports/projects/*',
    scope: 'accReports',
    modulePath: './App',
    layout: LAYOUTS.PROJECT_PAGE_LAYOUT,
    layoutProps: {
      currentToolId: TOOL_IDS.REPORTS,
      currentProductId: PRODUCT_IDS.BUILD,
    },
  },
  {
    path: '/insight/builder/home',
    scope: 'insightBuilder',
    modulePath: './Home',
    layout: LAYOUTS.PUBLIC_PAGE_LAYOUT,
    customTitle: (
      <TabTitle
        productId={PRODUCT_IDS.BUILD}
        toolId={TOOL_IDS.INSIGHT_BUILDER}
      />
    ),
  },
  {
    path: '/insight/builder/accounts/:accountId/*',
    scope: 'insightBuilder',
    modulePath: './App',
    layout: LAYOUTS.PUBLIC_PAGE_LAYOUT,
    customTitle: (
      <TabTitle
        productId={PRODUCT_IDS.INSIGHT}
        toolId={TOOL_IDS.INSIGHT_BUILDER}
      />
    ),
    layoutProps: {
      currentProductId: PRODUCT_IDS.INSIGHT,
      currentToolId: TOOL_IDS.INSIGHT_BUILDER,
      isUsersConstructionApi: true,
      renderSideNavigation: (props: ComponentProps<typeof SideNavigation>) => (
        <RemoteSideNavigation
          scope="insightBuilder"
          moduleName="./AccountSideNavigation"
          {...props}
        />
      ),
      renderTopNavigation: () => (
        <RemoteComponent scope="insightBuilder" moduleName="./TopNavigation" />
      ),
      variant: ProjectPageLayout.VARIANTS.ACCOUNT,
    },
  },
  {
    path: '/insight/data-connector/accounts/:accountId/*',
    scope: 'dataConnector',
    modulePath: './App',
    layout: LAYOUTS.PROJECT_PAGE_LAYOUT,
    layoutProps: {
      currentToolId: TOOL_IDS.DATA_CONNECTOR,
      currentProductId: PRODUCT_IDS.INSIGHT,
      renderSideNavigation: (props: ComponentProps<typeof SideNavigation>) => (
        <RemoteSideNavigation
          scope="accInsightComponents"
          moduleName="./SideNavigation"
          {...props}
          selectedId={TOOL_IDS.DATA_CONNECTOR}
        />
      ),
      variant: ProjectPageLayout.VARIANTS.ACCOUNT,
    },
  },
  {
    path: '/insight/model-analytics/accounts/:accountId/projects/:projectId/*',
    scope: 'accModelAnalytics',
    modulePath: './App',
    layout: LAYOUTS.PROJECT_PAGE_LAYOUT,
    layoutProps: {
      variant: ProjectPageLayout.VARIANTS.PROJECT,
      currentProductId: PRODUCT_IDS.INSIGHT,
      renderSideNavigation: () => null,
    },
  },
  {
    path: '/insight/model-analytics/accounts/:accountId/*',
    scope: 'accModelAnalytics',
    modulePath: './App',
    layout: LAYOUTS.PROJECT_PAGE_LAYOUT,
    layoutProps: {
      variant: ProjectPageLayout.VARIANTS.ACCOUNT,
      currentProductId: PRODUCT_IDS.INSIGHT,
      renderSideNavigation: () => null,
    },
  },
  {
    path: '/insight/reports/projects/*',
    scope: 'accReports',
    modulePath: './App',
    customTitle: <TabTitle toolId={TOOL_IDS.REPORTS} />,
    layout: LAYOUTS.PROJECT_PAGE_LAYOUT,
    layoutProps: {
      currentToolId: '',
      currentProductId: PRODUCT_IDS.INSIGHT,
      renderSideNavigation: () => null,
    },
  },
  {
    path: '/insight/reports/accounts/*',
    scope: 'accReports',
    modulePath: './App',
    layout: LAYOUTS.PROJECT_PAGE_LAYOUT,
    layoutProps: {
      variant: 'account',
      currentToolId: TOOL_IDS.REPORTS,
      currentProductId: PRODUCT_IDS.INSIGHT,
      renderSideNavigation: () => null,
    },
  },
  {
    path: '/docs/reports/projects/*',
    scope: 'accReports',
    modulePath: './App',
    layout: LAYOUTS.PROJECT_PAGE_LAYOUT,
    layoutProps: {
      currentToolId: TOOL_IDS.REPORTS,
      currentProductId: PRODUCT_IDS.DOCS,
    },
  },
  {
    path: '/cost/reports/projects/*',
    scope: 'accReports',
    modulePath: './App',
    layout: LAYOUTS.PROJECT_PAGE_LAYOUT,
    layoutProps: {
      currentToolId: TOOL_IDS.REPORTS,
      currentProductId: PRODUCT_IDS.COST,
      renderSideNavigation: (props: ComponentProps<typeof SideNavigation>) => (
        <RemoteSideNavigation
          scope="accCost"
          moduleName="./SideNavigation"
          selectedId={TOOL_IDS.REPORTS}
          {...props}
        />
      ),
    },
  },
  {
    path: '/takeoff/reports/projects/*',
    scope: 'accReports',
    modulePath: './App',
    layout: LAYOUTS.PROJECT_PAGE_LAYOUT,
    layoutProps: {
      currentToolId: TOOL_IDS.REPORTS,
      currentProductId: PRODUCT_IDS.TAKEOFF,
    },
  },
  {
    path: '/dc/reports/projects/*',
    scope: 'accReports',
    modulePath: './App',
    layout: LAYOUTS.PROJECT_PAGE_LAYOUT,
    layoutProps: {
      currentToolId: TOOL_IDS.REPORTS,
      currentProductId: PRODUCT_IDS.DESIGN_COLLABORATION,
    },
  },
  {
    path: '/model/reports/projects/*',
    scope: 'accReports',
    modulePath: './App',
    layout: LAYOUTS.PROJECT_PAGE_LAYOUT,
    layoutProps: {
      currentToolId: TOOL_IDS.REPORTS,
      currentProductId: PRODUCT_IDS.MODEL_COORDINATION,
    },
  },
  {
    path: '/cost/home/*',
    scope: 'accCost',
    modulePath: './Main',
    layout: LAYOUTS.PROJECT_PAGE_LAYOUT,
    layoutProps: {
      currentToolId: TOOL_IDS.HOME,
      currentProductId: PRODUCT_IDS.COST,
      renderSideNavigation: (props: ComponentProps<typeof SideNavigation>) => (
        <RemoteSideNavigation
          scope="accCost"
          moduleName="./SideNavigation"
          selectedId={TOOL_IDS.HOME}
          {...props}
        />
      ),
    },
  },
  {
    path: '/cost/budget/*',
    scope: 'accCost',
    modulePath: './Main',
    layout: LAYOUTS.PROJECT_PAGE_LAYOUT,
    layoutProps: {
      currentToolId: TOOL_IDS.BUDGET,
      currentProductId: PRODUCT_IDS.COST,
      renderSideNavigation: (props: ComponentProps<typeof SideNavigation>) => (
        <RemoteSideNavigation
          scope="accCost"
          moduleName="./SideNavigation"
          selectedId={TOOL_IDS.BUDGET}
          {...props}
        />
      ),
    },
  },
  {
    path: '/cost/cost/*',
    scope: 'accCost',
    modulePath: './Main',
    layout: LAYOUTS.PROJECT_PAGE_LAYOUT,
    layoutProps: {
      currentToolId: TOOL_IDS.COST,
      currentProductId: PRODUCT_IDS.COST,
      renderSideNavigation: (props: ComponentProps<typeof SideNavigation>) => (
        <RemoteSideNavigation
          scope="accCost"
          moduleName="./SideNavigation"
          selectedId={TOOL_IDS.COST}
          {...props}
        />
      ),
    },
  },
  {
    path: '/cost/changeorder/*',
    scope: 'accCost',
    modulePath: './Main',
    layout: LAYOUTS.PROJECT_PAGE_LAYOUT,
    layoutProps: {
      currentToolId: TOOL_IDS.CHANGE_ORDER,
      currentProductId: PRODUCT_IDS.COST,
      renderSideNavigation: (props: ComponentProps<typeof SideNavigation>) => (
        <RemoteSideNavigation
          scope="accCost"
          moduleName="./SideNavigation"
          selectedId={TOOL_IDS.CHANGE_ORDER}
          {...props}
        />
      ),
    },
  },
  {
    path: '/cost/forecast/*',
    scope: 'accCost',
    modulePath: './Main',
    layout: LAYOUTS.PROJECT_PAGE_LAYOUT,
    layoutProps: {
      currentToolId: TOOL_IDS.FORECAST,
      currentProductId: PRODUCT_IDS.COST,
      renderSideNavigation: (props: ComponentProps<typeof SideNavigation>) => (
        <RemoteSideNavigation
          scope="accCost"
          moduleName="./SideNavigation"
          selectedId={TOOL_IDS.FORECAST}
          {...props}
        />
      ),
    },
  },
  {
    path: '/cost/settings/*',
    scope: 'accCost',
    modulePath: './Main',
    layout: LAYOUTS.PROJECT_PAGE_LAYOUT,
    layoutProps: {
      currentToolId: TOOL_IDS.SETTINGS,
      currentProductId: PRODUCT_IDS.COST,
      renderSideNavigation: (props: ComponentProps<typeof SideNavigation>) => (
        <RemoteSideNavigation
          scope="accCost"
          moduleName="./SideNavigation"
          selectedId={TOOL_IDS.SETTINGS}
          {...props}
        />
      ),
    },
  },
  {
    path: '/build/issues/projects/:projectId/*',
    scope: 'accIssues',
    modulePath: './App',
    layout: LAYOUTS.PROJECT_PAGE_LAYOUT,
    layoutProps: {
      currentToolId: TOOL_IDS.ISSUES,
      currentProductId: PRODUCT_IDS.BUILD,
    },
  },
  {
    path: '/docs/issues/projects/:projectId/*',
    scope: 'accIssues',
    modulePath: './App',
    layout: LAYOUTS.PROJECT_PAGE_LAYOUT,
    layoutProps: {
      currentToolId: TOOL_IDS.ISSUES,
      currentProductId: PRODUCT_IDS.DOCS,
    },
  },
  {
    path: '/takeoff/home/projects/:projectId/*',
    scope: 'accTakeoff',
    modulePath: './Home',
    layout: LAYOUTS.PROJECT_PAGE_LAYOUT,
    layoutProps: {
      currentProductId: PRODUCT_IDS.TAKEOFF,
      currentToolId: TOOL_IDS.HOME,
    },
  },
  {
    path: '/takeoff/packages/projects/:projectId/*',
    scope: 'accTakeoff',
    modulePath: './Packages',
    layout: LAYOUTS.PROJECT_PAGE_LAYOUT,
    layoutProps: {
      currentProductId: PRODUCT_IDS.TAKEOFF,
      currentToolId: TOOL_IDS.PACKAGES,
    },
  },
  {
    path: '/takeoff/sheets/projects/:projectId/*',
    scope: 'accTakeoff',
    modulePath: './Sheets',
    layout: LAYOUTS.PROJECT_PAGE_LAYOUT,
    layoutProps: {
      currentProductId: PRODUCT_IDS.TAKEOFF,
      currentToolId: TOOL_IDS.SHEETS,
    },
  },
  {
    path: '/takeoff/settings/projects/:projectId/*',
    scope: 'accTakeoff',
    modulePath: './Settings',
    layout: LAYOUTS.PROJECT_PAGE_LAYOUT,
    layoutProps: {
      currentProductId: PRODUCT_IDS.TAKEOFF,
      currentToolId: TOOL_IDS.SETTINGS,
    },
  },
  {
    path: '/takeoff/estimate/projects/:projectId/*',
    scope: 'accTakeoff',
    modulePath: './Estimate',
    layout: LAYOUTS.PROJECT_PAGE_LAYOUT,
    layoutProps: {
      currentProductId: PRODUCT_IDS.TAKEOFF,
      currentToolId: TOOL_IDS.ESTIMATE,
    },
  },
  {
    path: '/takeoff/bidding/projects/:projectId/*',
    scope: 'accBidding',
    modulePath: './App',
    layout: LAYOUTS.PROJECT_PAGE_LAYOUT,
    layoutProps: {
      currentProductId: PRODUCT_IDS.TAKEOFF,
      currentToolId: TOOL_IDS.BIDDING,
    },
  },
  {
    path: '/model/*',
    scope: 'accModelCoordination',
    modulePath: './ExoSkeletonEntryPoint',
    excludeSubPaths: ['/model/members/*'],
    layout: LAYOUTS.PROJECT_PAGE_LAYOUT,
    layoutProps: {
      currentProductId: PRODUCT_IDS.MODEL_COORDINATION,
      fallbackParams: ['fallbackViewerUrl'],
      renderSideNavigation: (props: ComponentProps<typeof SideNavigation>) => {
        return (
          <RemoteSideNavigation
            scope="accModelCoordination"
            moduleName="./ExoSideNavigation"
            {...props}
          />
        );
      },
    },
  },
  {
    path: '/dc/*',
    scope: 'accDesignCollaboration',
    modulePath: './ExoSkeletonEntryPoint',
    excludeSubPaths: ['/dc/members/*'],
    layout: LAYOUTS.PROJECT_PAGE_LAYOUT,
    layoutProps: {
      currentProductId: PRODUCT_IDS.DESIGN_COLLABORATION,
    },
  },
  {
    path: '/build/assets/projects/:projectId/model-integration/*',
    scope: 'accAssets',
    layout: LAYOUTS.PROJECT_PAGE_LAYOUT,
    modulePath: './App',
    layoutProps: {
      currentToolId: TOOL_IDS.ASSETS,
      currentProductId: PRODUCT_IDS.BUILD,
      renderSideNavigation: () => null,
      renderTopNavigation: () => null,
    },
  },
  {
    path: '/build/assets/projects/:projectId/download',
    scope: 'accAssets',
    layout: LAYOUTS.PROJECT_PAGE_LAYOUT,
    modulePath: './App',
    layoutProps: {
      currentToolId: TOOL_IDS.ASSETS,
      currentProductId: PRODUCT_IDS.BUILD,
      renderSideNavigation: () => null,
    },
  },
  {
    path: '/build/assets/projects/:projectId/*',
    scope: 'accAssets',
    layout: LAYOUTS.PROJECT_PAGE_LAYOUT,
    modulePath: './App',
    layoutProps: {
      currentToolId: TOOL_IDS.ASSETS,
      currentProductId: PRODUCT_IDS.BUILD,
    },
  },
  {
    path: '/build/forms/projects/:projectUid/field-reports/create',
    scope: 'accForms',
    layout: LAYOUTS.PROJECT_PAGE_LAYOUT,
    modulePath: './App',
    layoutProps: {
      currentToolId: TOOL_IDS.FORMS,
      currentProductId: PRODUCT_IDS.BUILD,
      renderSideNavigation: () => null,
    },
  },
  {
    path: '/build/forms/projects/:projectUid/field-reports/:reportTypeUid/edit',
    scope: 'accForms',
    layout: LAYOUTS.PROJECT_PAGE_LAYOUT,
    modulePath: './App',
    layoutProps: {
      currentToolId: TOOL_IDS.FORMS,
      currentProductId: PRODUCT_IDS.BUILD,
      renderSideNavigation: () => null,
    },
  },
  {
    path: '/build/forms/*',
    scope: 'accForms',
    layout: LAYOUTS.PROJECT_PAGE_LAYOUT,
    modulePath: './App',
    layoutProps: {
      currentToolId: TOOL_IDS.FORMS,
      currentProductId: PRODUCT_IDS.BUILD,
    },
  },
  {
    path: '/account-admin/components/accounts/:accountId/classifications',
    scope: 'accLibrary',
    modulePath: './App',
    layout: LAYOUTS.PROJECT_PAGE_LAYOUT,
    layoutProps: ACCOUNT_ADMIN_LAYOUT_PROPS,
  },
  {
    path: '/project-admin/classifications/projects/:projectId/*',
    modulePath: './App',
    scope: 'accClassifications',
    layout: LAYOUTS.PROJECT_PAGE_LAYOUT,
    layoutProps: {
      currentToolId: TOOL_IDS.CLASSIFICATIONS,
      currentProductId: PRODUCT_IDS.PROJECT_ADMINISTRATION,
    },
  },
  {
    path: '/project-admin/locations/projects/:projectId/',
    scope: 'accLocations',
    layout: LAYOUTS.PROJECT_PAGE_LAYOUT,
    modulePath: './LocationsPage',
    layoutProps: {
      currentToolId: TOOL_IDS.LOCATIONS,
      currentProductId: PRODUCT_IDS.PROJECT_ADMINISTRATION,
    },
  },
  {
    path: '/locations/projects/:projectId/map',
    scope: 'accLocations',
    modulePath: './LocationsMap',
    layout: LAYOUTS.FULL_PAGE_LAYOUT,
  },
  {
    path: '/account-admin/components/accounts/:accountId/classifications/:classificationId',
    scope: 'accClassifications',
    modulePath: './LibraryClassificationStructure',
    layout: LAYOUTS.PROJECT_PAGE_LAYOUT,
    layoutProps: ACCOUNT_ADMIN_LAYOUT_PROPS,
  },
] satisfies Route[];
